// extracted by mini-css-extract-plugin
export default {"action":"MessageActions-module__action--c4e29"};